import { inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { Observable } from 'rxjs'

import { PaginationQueryParams } from '@flowx/designer/shared/api/api-http.service'
import { GridSearchService } from '@flowx/designer/shared/services/grid-search.service'
import {
  PaginatedEndpoint,
  PaginatedResponse,
} from '@flowx/designer/shared/services/paginated-datasource'

import { AccessManagementGroup, AccessManagementUser } from '../../workspace.utils'
import { ACCESS_MANAGEMENT_GROUPS_API } from '../../workspaces'

export class GroupsGridSearch extends GridSearchService<PaginationQueryParams> {
  #accessManagementGroupsApi = inject(ACCESS_MANAGEMENT_GROUPS_API)

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<AccessManagementGroup, PaginationQueryParams>
    sort: { property: string; direction: 'asc' | 'desc' }
    query: Partial<PaginationQueryParams>
  } {
    return {
      endpoint: this.#getGroups.bind(this),
      sort: null,
      query: { filterKey: '' },
    }
  }

  #getGroups(
    paginationParams: PaginationQueryParams,
    query: Partial<PaginationQueryParams>
  ): Observable<PaginatedResponse<AccessManagementGroup>> {
    return this.#accessManagementGroupsApi.getGroups({ ...paginationParams, ...query })
  }
}

export class GroupUsersGridSearch extends GridSearchService<PaginationQueryParams> {
  #accessManagementGroupsApi = inject(ACCESS_MANAGEMENT_GROUPS_API)
  #route = inject(ActivatedRoute)
  groupId: string

  constructor(groupId: string) {
    super()
    this.groupId = groupId
  }

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<AccessManagementUser, PaginationQueryParams>
    sort: { property: string; direction: 'asc' | 'desc' }
    query: Partial<PaginationQueryParams>
  } {
    return {
      endpoint: this.#getGroupUsers.bind(this),
      sort: null,
      query: { filterKey: this.#route.snapshot.queryParams?.searchQuery ?? '' },
    }
  }

  #getGroupUsers(
    paginationParams: PaginationQueryParams,
    query: Partial<PaginationQueryParams>
  ): Observable<PaginatedResponse<AccessManagementUser>> {
    return this.#accessManagementGroupsApi.getGroupUsersPaginated(this.groupId, {
      ...paginationParams,
      ...query,
    })
  }
}
